import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LandingView from '../components/LandingView';
import { ProgramMoment } from '../components/GuestProgram';
import { ensureFontsLoaded } from '../personalization';
import { useT } from '../i18n';
import { Spinner } from '../components/ui';
import '../styles/guest.css';

interface Account {
  partner1: string;
  partner2: string;
  fontFamily?: string | null;
  bodyFont?: string | null;
  primaryColor?: string | null;
  heroImage?: string | null;
  heroImagePositionY?: number | null;
  weddingDate?: string | null;
  venueName?: string | null;
  venueAddress?: string | null;
}

const Landing: React.FC = () => {
  const navigate = useNavigate();
  const t = useT();
  const [account, setAccount] = useState<Account | null>(null);
  const [notFound, setNotFound] = useState(false);
  const [program, setProgram] = useState<ProgramMoment[]>([]);

  useEffect(() => {
    fetch('/api/account')
      .then((res) => {
        if (!res.ok) throw new Error('not found');
        return res.json();
      })
      .then((data: Account) => {
        setAccount(data);
        if (data.fontFamily || data.bodyFont) ensureFontsLoaded();
      })
      .catch(() => setNotFound(true));
    // Programme du déroulé (moments « Invités ») : facultatif, n'attend pas
    fetch('/api/dayplan/program')
      .then((res) => (res.ok ? res.json() : { moments: [] }))
      .then((data: { moments: ProgramMoment[] }) => setProgram(data.moments || []))
      .catch(() => {});
  }, []);

  if (notFound) {
    return (
      <div className="gu-notfound gu-theme">
        <div className="gu-notfound-inner">
          <h1>{t('Espace introuvable')}</h1>
          <p>{t('Cette adresse ne correspond à aucun mariage.')}</p>
          <a className="gu-cta" href="https://www.please-rsvp.com">{t('Créer mon espace RSVP')}</a>
        </div>
      </div>
    );
  }

  // Tant que le compte n'est pas chargé : spinner (jamais « Prénom & Prénom »)
  if (!account) return <Spinner page />;

  return (
    <LandingView
      partner1={account.partner1}
      partner2={account.partner2}
      primaryColor={account.primaryColor}
      fontFamily={account.fontFamily}
      bodyFont={account.bodyFont}
      heroImage={account.heroImage}
      heroImagePositionY={account.heroImagePositionY}
      weddingDate={account.weddingDate}
      venueName={account.venueName}
      venueAddress={account.venueAddress}
      program={program}
      onRespond={() => navigate('/rsvp')}
    />
  );
};

export default Landing;
